export const getColorProgress = (value: number) => {
    if (value < 40) return 'var(--hr-color-spectre-red-500)';
    if (value < 70) return 'var(--hr-color-spectre-blue-500)';

    return 'var(--hr-color-spectre-green-500)';
};
